import { Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})

export class ProgressBarSharedComponent {
    @Input() barStyle: 'warn' | 'danger' | 'secondary' = 'secondary';
    @Input() progress = 0;
}
